import { apiCall } from ".";

export const transactionHistoryApi = (params: {}) => {
  return apiCall(true).get("transactions/", { params });
};
